import moment from 'moment';
class registrations {
  constructor(
    ent,
    sal,
    conceptoId,
    concepto,
    csCostoId,
    csCosto) {
    this.ent = ent;
    this.sal = sal;
    this.conceptoId = conceptoId;
    this.concepto = concepto;
    this.csCostoId = csCostoId;
    this.csCosto = csCosto;
  }
  static fromJson({
    ent,
    sal,
    conceptoId,
    concepto,
    csCostoId,
    csCosto
  }) {
    return new registrations(
     ent,
     sal,
     conceptoId,
     concepto,
     csCostoId,
     csCosto
    );
  }
}
export default registrations;
